import { Info } from 'lucide-react'

export function BranchNameHint() {
  return (
    <p
      className="flex items-start gap-1 mt-1 text-xs leading-[1.6] tracking-[0.015em] text-button"
      data-testid="branch-name-hint"
    >
      <Info className="h-3.5 w-3.5 mt-0.5 shrink-0" aria-hidden="true" />
      <span>
        This branch name will be used (with per-repo dedup on collision) in every
        repository the AI decides to modify. For example: <span className="font-medium">feature/wi-1234</span> in
        one repository, <span className="font-medium">feature/wi-1234-2</span> in another if the first name was already taken there.
      </span>
    </p>
  )
}
